import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        this.$el = this.el
        this.currentFilterIndex = 0

        this.events = {
            change: {
                select: 'onSelectChange'
            },
            click: {
                filter: 'onFilterClick'
            }
        }
    }

    init() {
        // Check if a filter is active
        const defaultFilter = Array.from(this.$('filter')).find(filter => filter.classList.contains('is-active'))
        if (defaultFilter) this.updateFilterIndex(defaultFilter)

        this.setIndexes()
    }

    onFilterClick(e) {
        const selectedFilter = e.currentTarget
        const url = this.getData('url', selectedFilter)
        if (!url) return

        // Remove active state on old filter
        this.$('filter')[this.currentFilterIndex].classList.remove('is-active')

        // Add active state on new filter
        selectedFilter.classList.add('is-active')

        this.updateFilterIndex(selectedFilter)
        this.call('goTo', { url: url, transition: 'list' }, 'Load')
    }

    onSelectChange(e) {
        const url = e.currentTarget.value
        if (!url) return

        this.call('goTo', { url: url, transition: 'list' }, 'Load')
    }

    updateFilterIndex(selectedFilter) {
        let index = 0
        while (index < this.$('filter').length) {
            const filter = this.$('filter')[index]
            if (filter == selectedFilter) this.currentFilterIndex = index
            index++
        }
    }

    setIndexes() {
        let index = 0
        while (index < this.$('filter').length) {
            const filterItem = this.$('filter')[index].parentNode
            filterItem.style.setProperty('--index', index)
            index++
        }
    }
}
